export const withParams = (params?: Record<string, boolean | number | string>) => (path: string) =>
  params
    ? Object.entries(params).reduce((routeAcc, [param, value]) => routeAcc.replace(`:${param}`, value.toString()), path)
    : path
